import Plyr from 'plyr'

const usePlyrVideo = () => {
  new Plyr('[data-name="player"]')
}

export default usePlyrVideo
